import React from 'react'

function Instagram(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0.73 0.58 33.82 33.83"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M17.63.58a16.91 16.91 0 110 33.83 16.91 16.91 0 010-33.83zm0 1.17a15.75 15.75 0 10.02 31.5 15.75 15.75 0 00-.02-31.5zm5.01 7.58a3.16 3.16 0 013.16 3.16v10.02a3.16 3.16 0 01-3.16 3.16H12.63a3.16 3.16 0 01-3.16-3.16V12.49a3.16 3.16 0 013.16-3.16h10.01zm-9.14 6.5h-2.44v6.68c0 .86.7 1.56 1.57 1.56h10.01c.86 0 1.56-.7 1.56-1.56v-6.69h-2.43a4.47 4.47 0 11-8.27 0zm4.14-1.2a2.87 2.87 0 100 5.73 2.87 2.87 0 000-5.73zm6.27-3.42h-.36l-2.4.01V14h2.76V11.2z"
            />
        </svg>
    )
}

export default Instagram
